import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Wallet from '../components/wallet/Wallet'
import { HOME_URL } from '../../../constants/navigation'
import { getWallet } from '../../../store/actions/wallet'
import { getWalletAddressSelector } from '../../../store/selectors/wallet'

const WalletContainer = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const walletAddressMembership = useSelector(getWalletAddressSelector)
  const { isProcessing, nfts } = useSelector((state) => {
    return state.walletReducer.walletProfile
  })

  useEffect(() => {
    const membershipNumber = walletAddressMembership.membershipNumber
    if (membershipNumber) {
      dispatch(getWallet(membershipNumber))
    } else {
      navigate(HOME_URL, { replace: true })
    }
  }, [walletAddressMembership.membershipNumber])

  return <Wallet t={t} nfts={nfts} loading={isProcessing} />
}

export default WalletContainer
